import type { MealMonitoringEntity } from './MealMonitoringEntity'

export class MealMonitoringResponseEntity {
  showCompletedOrderDurationInSecond?: number
  showCanceledOrderDurationInSecond?: number
  meals?: Array<MealMonitoringEntity> | null
}
